import { TextField } from "@fluentui/react/lib/TextField";

import { IEditFieldProps } from "../IEditFieldProps";
import { useEditValue } from "../Hooks/UseEditValue";

export function EditText(props: IEditFieldProps): JSX.Element {
  const { htmlId, disabled } = props;
  const { errorMessage, value, onChange } = useEditValue<string>(props);

  return (
    <TextField id={htmlId} value={value ?? ``} onChange={onChange} errorMessage={errorMessage} disabled={disabled} />
  );
}
